module.exports = __webpack_public_path__ + "static/knittednavystripemain-a1ac9e097573b03d793262e9a1d4e376.jpeg";